import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDuration } from "@/components/map/mapUtils";
import { PersonSimpleRun, Bicycle, PersonSimpleWalk, MapPin } from "@phosphor-icons/react";

const SPORTS = [
  { id: "run", label: "Бег", icon: PersonSimpleRun, color: "#00e676" },
  { id: "bike", label: "Вело", icon: Bicycle, color: "#0084ff" },
  { id: "walk", label: "Ходьба", icon: PersonSimpleWalk, color: "#a970ff" },
];
const dayLabel = (iso) => new Date(iso + "T12:00:00Z").toLocaleDateString("ru-RU", { weekday: "short" });

export default function GpsWeekCard({ member = "" }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/gps/summary?days=7${member ? `&member=${member}` : ""}`)
      .then((r) => setData(r.data)).catch(() => {});
  }, [member]);

  if (!data || data.total.count === 0) return null;
  const maxDay = Math.max(...data.daily.map((d) => d.run + d.bike + d.walk), 0.1);

  return (
    <div className="glass-card p-5" data-testid="gps-week-card">
      <div className="flex items-center gap-2 mb-4">
        <MapPin size={18} weight="duotone" className="text-[#ff9100]" />
        <h3 className="text-sm font-semibold flex-1">GPS-активность · 7 дней</h3>
        <span className="text-xs text-muted-foreground num">
          {data.total.distance_km} км · {fmtDuration(data.total.duration_s)} · {data.total.count} трен.
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-4">
        {SPORTS.map(({ id, label, icon: Icon, color }) => (
          <div key={id} className="rounded-lg bg-white/[0.04] border border-white/[0.06] p-3 text-center" data-testid={`gps-sport-${id}`}>
            <Icon size={16} weight="duotone" style={{ color }} className="mx-auto mb-1" />
            <div className="font-heading text-lg font-extrabold num">{data.sports[id].distance_km}<span className="text-[10px] text-muted-foreground font-normal"> км</span></div>
            <div className="text-[10px] text-muted-foreground">{label} · {data.sports[id].count}×</div>
          </div>
        ))}
      </div>
      <div className="flex items-end gap-1.5 h-16" data-testid="gps-week-bars">
        {data.daily.map((d) => {
          const total = d.run + d.bike + d.walk;
          return (
            <div key={d.date} className="flex-1 flex flex-col items-center gap-1" title={`${d.date}: ${total.toFixed(2)} км`}>
              <div className="w-full max-w-[36px] flex flex-col-reverse rounded-sm overflow-hidden" style={{ height: `${Math.max(4, (total / maxDay) * 48)}px` }}>
                {SPORTS.map(({ id, color }) => d[id] > 0 && (
                  <div key={id} style={{ background: color, height: `${(d[id] / (total || 1)) * 100}%` }} />
                ))}
                {total === 0 && <div className="h-full bg-white/[0.05]" />}
              </div>
              <span className="text-[9px] text-muted-foreground">{dayLabel(d.date)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
